import React from 'react';
import DatePicker from 'react-datepicker';
import MultiDatePicker, { DateObject } from 'react-multi-date-picker';
import Select from 'react-select';
import {
  statisticNotificationPeriodOptions,
  statisticNotificationStopType,
  statisticNotificationTimeOptions,
  statisticNotificationStopPeriod,
  statisticNotificationStopFrequency,
  timeOptions,
} from '../../../../constants/forms/options';
import DateCalendar from '../../../calendars/DateCalendar/DateCalendar';

const NotificationStatisticsSettings = ({ handelSettings, notification_settings, errors }) => {
  const handleSelectWeekDays = (weekDay) => {
    if (notification_settings.statistic_notification_sending_week_days) {
      if (!notification_settings.statistic_notification_sending_week_days.includes(weekDay)) {
        handelSettings(
          [...notification_settings.statistic_notification_sending_week_days, weekDay],
          'statistic_notification_sending_week_days',
        );
      } else {
        handelSettings(
          notification_settings.statistic_notification_sending_week_days.filter((item) => item !== weekDay),
          'statistic_notification_sending_week_days',
        );
      }
    }
  };

  return (
    <div className="form-control-item-settings">
      <div className="form-settings-label">
        <label className="form-label form-label-big">Notify users with the Statistics report about the form completion</label>
      </div>
      <div className="form-settings-inputs">
        <div className="d-flex">
          <div className={`form-control-radio`}>
            <input
              name="should_notify_about_statistics"
              type="radio"
              value="true"
              onChange={() => handelSettings(true, 'should_notify_about_statistics')}
              checked={notification_settings.should_notify_about_statistics}
            />
            <span>Yes</span>
          </div>
          <div className={`form-control-radio`}>
            <input
              name="should_notify_about_statistics"
              type="radio"
              value="false"
              onChange={() => handelSettings(false, 'should_notify_about_statistics')}
              checked={notification_settings.should_notify_about_statistics === false}
            />
            <span>No</span>
          </div>
        </div>
        {notification_settings.should_notify_about_statistics && (
          <>
            <div className="form-control-item-group">
              <label className="form-label">Repeat every</label>
              <div className="d-flex gap-3">
                <div className="form-control-item-half">
                  <Select
                    hideSelectedOptions={false}
                    isSearchable={false}
                    options={statisticNotificationTimeOptions}
                    value={notification_settings.statistic_notification_repeat}
                    onChange={(e) => handelSettings(e, 'statistic_notification_repeat')}
                    className="form-control-select"
                    placeholder="Select quantity"
                    classNamePrefix="react-select"
                  ></Select>
                  <span className="form-error">{errors?.statistic_notification_repeat && errors.statistic_notification_repeat[0]}</span>
                </div>

                <div className="form-control-item-half">
                  <Select
                    hideSelectedOptions={false}
                    isSearchable={false}
                    options={statisticNotificationPeriodOptions}
                    value={notification_settings.statistic_notification_period}
                    onChange={(e) => handelSettings(e, 'statistic_notification_period')}
                    className="form-control-select"
                    placeholder="Period"
                    classNamePrefix="react-select"
                  ></Select>
                  <span className="form-error">{errors?.statistic_notification_period && errors.statistic_notification_period[0]}</span>
                </div>
              </div>
            </div>

            {notification_settings.statistic_notification_period?.value == 'weekly' && (
              <div className={'form-item mb-6'}>
                <label htmlFor="">Send on these days:</label>
                <div className={'week-grid'}>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(0)}
                      onChange={(e) => handleSelectWeekDays(0)}
                    />{' '}
                    <span>Sun</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(1)}
                      onChange={(e) => handleSelectWeekDays(1)}
                    />{' '}
                    <span>Mon</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(2)}
                      onChange={(e) => handleSelectWeekDays(2)}
                    />{' '}
                    <span>Tue</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(3)}
                      onChange={(e) => handleSelectWeekDays(3)}
                    />{' '}
                    <span>Wed</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(4)}
                      onChange={(e) => handleSelectWeekDays(4)}
                    />{' '}
                    <span>Thu</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(5)}
                      onChange={(e) => handleSelectWeekDays(5)}
                    />{' '}
                    <span>Fri</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.statistic_notification_sending_week_days?.includes(6)}
                      onChange={(e) => handleSelectWeekDays(6)}
                    />{' '}
                    <span>Sat</span>
                  </div>
                </div>
                <span className="form-error">
                  {errors?.statistic_notification_sending_week_days && errors.statistic_notification_sending_week_days[0]}
                </span>
              </div>
            )}

            {notification_settings.statistic_notification_period?.value == 'monthly' && (
              <div className={'form-item multi-date-picker disabled-change-month mb-6'}>
                <label className="form-label">Send on days</label>
                <div className={'clear-datepicker'}>
                  <MultiDatePicker
                    multiple
                    format={'DD'}
                    editable={false}
                    placeholder={'Choose Days'}
                    currentDate={
                      new DateObject({
                        year: 2024,
                        month: 12,
                        day: 1,
                      })
                    }
                    value={notification_settings.statistic_notification_sending_month_days}
                    onChange={(dates) => {
                      handelSettings(
                        dates.map((value) => value),
                        'statistic_notification_sending_month_days',
                      );
                    }}
                  />
                  {notification_settings.statistic_notification_sending_month_days?.length > 0 && (
                    <button onClick={() => handelSettings([], 'statistic_notification_sending_month_days')} className={'clear'}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clipPath="url(#clip0_5205_22763)">
                          <path
                            d="M12.5001 7.5013L7.50008 12.5013M7.50008 7.5013L12.5001 12.5013M18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346C5.39771 18.3346 1.66675 14.6037 1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797C14.6025 1.66797 18.3334 5.39893 18.3334 10.0013Z"
                            stroke="#D92D20"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_5205_22763">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  )}
                </div>
                <span className="form-error">
                  {errors?.statistic_notification_sending_month_days && errors.statistic_notification_sending_month_days[0]}
                </span>
              </div>
            )}

            <div className="form-control-item-group form-item-time">
              <label className="form-label">Time</label>
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                options={timeOptions}
                value={notification_settings.statistic_notification_sending_time}
                onChange={(e) => handelSettings(e, 'statistic_notification_sending_time')}
                className="form-control-select"
                placeholder="Period"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">
                {errors?.statistic_notification_sending_time && errors.statistic_notification_sending_time[0]}
              </span>
            </div>

            <div className="form-control-item-group">
              <label className="form-label">When Statistic notifications should stop being sent</label>
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                options={statisticNotificationStopType}
                value={notification_settings.statistic_notification_stop_type}
                onChange={(e) => handelSettings(e, 'statistic_notification_stop_type')}
                className="form-control-select"
                menuPlacement="auto"
                placeholder="Choose"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">{errors?.statistic_notification_stop_type && errors.statistic_notification_stop_type[0]}</span>
            </div>

            {notification_settings.statistic_notification_stop_type?.value === 'specific_date' && (
              <div className="form-control-item-group">
                <label className="form-label">Date</label>
                <DateCalendar
                  selectedDate={notification_settings.statistic_notification_stop_date}
                  handleChange={(date) => handelSettings(date, 'statistic_notification_stop_date')}
                  isClearable
                  placeholderText="Choose Date"
                />
                <span className="form-error">{errors?.statistic_notification_stop_date && errors.statistic_notification_stop_date[0]}</span>
              </div>
            )}

            {notification_settings.statistic_notification_stop_type?.value === 'interval' && (
              <div className="form-control-item-group">
                <label className="form-label">Choose period</label>
                <div className="d-flex gap-3">
                  <div className="form-control-item-half">
                    <Select
                      hideSelectedOptions={false}
                      isSearchable={false}
                      menuPlacement="top"
                      options={statisticNotificationStopPeriod}
                      value={notification_settings.statistic_notification_stop_period}
                      onChange={(e) => handelSettings(e, 'statistic_notification_stop_period')}
                      className="form-control-select"
                      placeholder="Select"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.statistic_notification_stop_period && errors.statistic_notification_stop_period[0]}
                    </span>
                  </div>

                  <div className="form-control-item-half">
                    <Select
                      hideSelectedOptions={false}
                      isSearchable={false}
                      menuPlacement="top"
                      options={statisticNotificationStopFrequency}
                      value={notification_settings.statistic_notification_stop_frequency}
                      onChange={(e) => handelSettings(e, 'statistic_notification_stop_frequency')}
                      className="form-control-select"
                      placeholder="Period"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.statistic_notification_stop_frequency && errors.statistic_notification_stop_frequency[0]}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NotificationStatisticsSettings;
